import { render, staticRenderFns } from "./Key.vue?vue&type=template&id=83f246ce&scoped=true"
import script from "./Key.vue?vue&type=script&lang=ts"
export * from "./Key.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83f246ce",
  null
  
)

export default component.exports